import { SearchHitFragment } from '../../generated/graphql';
import type { MapRef } from 'react-map-gl';
import { WebMercatorViewport } from '@math.gl/web-mercator';

export const getBoundsForHits = (hits: SearchHitFragment[], defaultZoom: number) => {
    // Calculate corner values of bounds
    const pointsLong = hits.map(
        ({
            rentalUnit: {
                accommodation: {
                    coordinates: { lon },
                },
            },
        }) => lon
    );
    const pointsLat = hits.map(
        ({
            rentalUnit: {
                accommodation: {
                    coordinates: { lat },
                },
            },
        }) => lat
    );
    const cornersLongLat: [[number, number], [number, number]] = [
        [Math.min(...pointsLong), Math.min(...pointsLat)],
        [Math.max(...pointsLong), Math.max(...pointsLat)],
    ];
    // Use WebMercatorViewport to get center longitude/latitude and zoom
    const viewport = new WebMercatorViewport({ width: 800, height: 600 }).fitBounds(cornersLongLat, {
        padding: 200,
    });
    const { longitude, latitude, zoom } = viewport;
    return { longitude, latitude, zoom: Math.min(Math.max(defaultZoom, zoom), 16) };
};

const useBounds = (mapRef?: { current?: MapRef | null }) => mapRef?.current?.getMap().getBounds().toArray().flat();

export default useBounds;
